import React from "react";
import { Link } from "react-router-dom";

type ComponentData={
    less: string,
    more:string,
};

const ReadMoreTableComponent=({less,more}:ComponentData)=>{

    const [expand,setExpand]=React.useState(false);

    return (
        <>
        {!expand && <>{less}...
          <Link to="" onClick={()=>{
            setExpand(true);
          }}>Read More</Link></>}
        {expand && <>{more}
          <Link to="" onClick={()=>{
            setExpand(false);
          }}>Show Less</Link></>}
        </>
      );
}

export default ReadMoreTableComponent;